import { digitalDeliveryServiceQueryToForm as serviceQueryToForm, digitalDeliveryQueryToForm as queryToForm } from './digitalDeliveryQueryToForm';

export default {queryToForm, serviceQueryToForm}